import React, { CSSProperties } from 'react';
import classes from './ColorPicker.module.scss';
import classNames from 'classnames';

export type ColorPickerViewProps = {
  //
  action: () => void;
  color: string;
  disabled?: boolean;
  selected?: boolean;
};

export const ColorPickerView = (props: ColorPickerViewProps): JSX.Element => {
  const globalClasses = classNames(classes.ColorPicker, {
    [classes.Selected]: !!props.selected && !props.disabled,
    [classes.ColorPickerDisabled]: !!props.disabled
  });
  const handlerClasses = classNames(classes.InnerCircle, {
    [classes.InnerCircleSelected]: !!props.selected && !props.disabled
  });
  const pickerStyle: CSSProperties = props.disabled
    ? {
        backgroundColor: '#eef0f4'
      }
    : {
        backgroundColor: props.color
      };
  return (
    <div className={globalClasses}>
      <a onClick={() => props.action()} style={pickerStyle} className={handlerClasses}>
        <span className={'show-for-sr'}>{props.color}</span>
      </a>
    </div>
  );
};
